<template>
 <div class="photo-edit-form">

  <v-container>
    <v-form v-if="isAuthenticated && image" @keyup.enter.prevent="update" @submit.prevent="update" ref="form" lazy-validation>
    <h3>{{ image.title }}</h3>
    <br />
    <img :src="image.display" />
    <v-btn class="save" :dark="$vuetify.theme.dark" type="submit">Save</v-btn>
    <h3> love: {{ image.votes_count }} </h3>
    <br />
    <v-text-field
        v-model="image.title"
        label="Image title"
        :counter="250"
        required
      ></v-text-field>
      <v-text-field
        v-model="image.description"
        label="Image description"
        :counter="500"
        required     
      ></v-text-field>
        <v-row align=center>
            <v-col cols="12">
                <Exif :items="exif"/>
            </v-col>
        </v-row>
        <v-row align="center" no-gutter>
            <GroupEdit 
            :groups="user.memberships"
            :posts="image.collectives"
            type="collective" 
            @add-group="addGroup"
            @remove-group="removeGroup"
            />
            <GroupEdit 
            :groups="user.memberships" 
            :posts="image.projects"
            type="project" 
            @add-group="addGroup"
            @remove-group="removeGroup"

            />
            <GroupEdit 
            :groups="user.memberships"
            :posts="image.competitions"
            type="competition" 
            @add-group="addGroup"
            @remove-group="removeGroup"
   
            />
            <GroupEdit 
            :groups="user.memberships"
            :posts="image.workshops"
            type="workshop" 
            @add-group="addGroup"
            @remove-group="removeGroup"
      
            />
        </v-row>

    </v-form>
  </v-container>
 </div>
</template>

<script>
import { mapState } from 'vuex'
import Icons from '@/components/gallery/Icons'
import GroupEdit from '@/components/group/Edit'
import { userMixin, imageMixin, groupMixin } from '@/functions/mixins'
import Exif from '@/components/image/Exif'

export default { 
        name: 'PhotoEdit',
         components: { 
            Icons,
            GroupEdit,
            Exif
        },
        mixins: [userMixin, imageMixin, groupMixin],
        data() {
            return {
                loading: true,
                image_id: this.$route.params.image_id
            }
        },
        computed: {
            ...mapState({
                last_uploaded: state => state.image.last_uploaded
            }),
            image() {
                return this.filteredById(this.image_id)
            },
            exif() {
                let exif = this.image.exif.replace(/'/g, '"');
                try {
                    JSON.parse(exif)
                    return JSON.parse(exif)
                } catch (e) {
                    return {}
                }    
            }
        },
        watch: {
            '$route' () {
                if(this.$route.params.image_id) {
                    this.image_id = this.$route.params.image_id
                }
                window.scrollTo(0, 0)    
            },
            image () {
                if(this.loading) {
                    this.loading=false
                    // this.buildGroups()
                }
            },
            last_uploaded () {
                this.image_id = this.last_uploaded
            }
        },
        methods: {
          update () {
            this.$store.dispatch('image/updateImage', this.image );
            if(this.image_id != this.$route.params.image_id) this.image_id = 0
          }
        }
    }
</script>

<style scoped>
.editform {
  padding-top: 50px;
}

.save {margin: 20px;}

.collectives {
    background-color: yellow !important;
}
</style>